import React, { useEffect } from "react";
import { PageHeader, MyTextInput } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// material ui
import {
  Card,
  CardHeader,
  IconButton,
  Grid,
  Box,
  CardContent,
} from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import { FormSubmitButton, CommonCurdPopUp, MuiAutocomplete } from "../../../../components";
import Notifier from "../../../../components/common/Notifier";
import ErrorNotifier from "../../../../components/common/ErrorNotifier";
// redux

import { getAccountById } from "../../../../features/customer/accountSlice";

import {
  createAccountMappingChr, getAccountMappingChr, resetMessage,
  resetErrMessage,
} from "../../../../features/auth/authChrSlice";

// --------------------------------------------------------------

const validationSchema = Yup.object({
  accountName: Yup.object().nullable().required("Account Name is required")
});

//   ------------------------------------------------------------------------------------------

const AddQuestionType = (props) => {

  // const { message, errMessage } = useSelector((state) => ({
  //   ...state.questionType,
  // }));

  const { selectedData, message, errMessage,accountMappingdata } = useSelector((state) => ({ ...state.authChr }))
  const { accountData, accountIdData } = useSelector((state) => ({
    ...state.account,
  }));


  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      accountName: "",
      questionType: "",
      responseType: "",
      comments: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(
        createAccountMappingChr({
          assessmentCustomerAccountId: values?.accountName?.id,
          assessmentUserChrId: selectedData?.
            assessmentUserChr?.id
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            props.close();
            dispatch(getAccountMappingChr(selectedData?.
              assessmentUserChr?.id));
          }, 2000);
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
      });
    },
  });


  useEffect(() => {

    dispatch(getAccountById({
      assessmentCustomerId: selectedData?.
        assessmentUserChr?.assessmentCustomer?.id
    }))
  }, [])



  console.log("mapping rendered")
  console.log(accountIdData)

  return (
    <>

      {props?.showAdd && <CommonCurdPopUp
        heading={`Map Accounts`}
        mediumScreen={true}
        close={props.close}
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11} >
            <Grid item xs={12} sm={12} md={12}>
              <MuiAutocomplete

                name="accountName"
                options={accountIdData?.filter((data) => 
                  !accountMappingdata ?.some((dataTwo) => data?.id === dataTwo?.id)
                )}
                setValue={(name, newValue) => {

                  formik.setFieldValue(name, newValue)
                  // formik.setFieldValue("account", "")

                }
                }
                value={formik.values.accountName}
                optionValue="accountName"
                label="Account Name"
                required={true}
                error={formik.touched.accountName && Boolean(formik.errors.accountName)}
                helperText={formik.touched.accountName && formik.errors.accountName}
              />
            </Grid>

          </Grid>
          <Box style={{ width: "100%", textAlign: "center" }} >

            <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
              Submit
            </FormSubmitButton>
          </Box>
        </Grid>

      </CommonCurdPopUp>}
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}

    </>
  );
};

export default AddQuestionType;
